import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
//
//import DeliveryLocations from './../Components/DeliveryLocations'
//
import AccountResources from './../Account/Resources/commonfunctions.js';

//
let service = new services();

export default {
    name: 'PlacedOrder',
    mixins: [AccountResources],
    data () {
        return {
            headerdata:{
                'name':'Placed Order',
            },
            //
            set_view_box:'',
            order_item:{}
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
    },
    methods: {
        preset() {
            this.loading = true;
            //../
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    //
                    localforage.getItem(service.bdb_name, function(err, value) { //quick with the callback version
                        if(value != undefined) {
                            self.sellpoint = value;
                            //
                            if(self.$route.params.ref && (self.$route.params.ref != '')){
                                var payload = {
                                    module:3,
                                    module_id:self.sellpoint.business_id,
                                    ref:self.$route.params.ref
                                }    
                                self.getOrderDetails(payload);
                            }
                            //get some core details
                            //self.setBusinessDetails();
                        }else{
                            self.loading = false;
                        }
                    });
                }else {
                    self.loading = false;
                    self.$router.push('/login')
                }
                
            });
            
        },

        setViewBox(view){
            this.setMenuTabInnerView('setOptions');
            //
            this.set_view_box = view;
            //this.toggleSingleComponent(view);
        },

        setRate(item,rate){
            this.order_item = item;
            this.order_item.product_item_rate = rate;
            //set rate
            // for (let i = 1; i <= rate; i++) {
                for (let i = 1; i <= 5; i++) {
                if(i <= rate){
                    document.getElementById('rate-'+i).style.display = 'none';
                    document.getElementById('rated-'+i).style.display = 'block';
                }else{
                    document.getElementById('rate-'+i).style.display = 'block';
                    document.getElementById('rated-'+i).style.display = 'none';
                }
            }
        },

        submitReview(){
            // if((this.order_item.product_item_review == "") && (this.order_item.product_item_rate == 0)){
                this.order_item.data_processing_message = "Please review and rate";
            if((this.order_item.product_item_rate < 0)){
                this.data_processing_message = "Please rate";
            }else{
                this.activate_processing();
                var payload = {
                    'product_reviewed_by': this.user.user_id,
                    'product_id': this.order_item.product_id,
                    'product_item_id': this.order_item.product_item_id,
                    'product_item_order_cost': this.order_item.order_item_total,
                    'product_review': this.order_item.product_item_review || '',
                    'product_rate': this.order_item.product_item_rate,
                }
                service.addProductReview(this, payload).then(response => {
                    if(response.body.status == 201) {
                        this.deactivate_processing();
                    }
                }).catch((err) => {})
            }
            this.componentOrderItemReviewKey++;
                
        },
},
created: function(){
    this.preset();
}
}



// WEBPACK FOOTER //
// ./src/pages/ManageOrder/script.js